import { getPrefixedKey } from '../state/utils/persistedAtom';
import { PLANNING_SESSION_KEYS } from '../state/planning/session';
import { clearLocalSetting } from '../components/hooks/useLocalConfig';

/**
 * Clears the per-user Planning session state on logout (SEABER-6666):
 * the persisted filter/timeline atoms and the saved scenario. Other user
 * preferences stored in localConfigSettings (table columns, filters, …) are
 * preserved. No-op outside the browser.
 */
export const clearPersistedSession = (): void => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return;
  }

  PLANNING_SESSION_KEYS.forEach((key) => {
    localStorage.removeItem(getPrefixedKey(key));
  });

  clearLocalSetting('scenarioCIDSaved');
};
